import request from '@/utils/request' // 引入封装的request.js文件

// 提交问题反馈
export function feedbackSubmit(data) {
  return request({
    url: '/problem/feedback/insert',
    method: 'post',
    data
  })
}